import { useEffect } from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { mergeRegister } from '@lexical/utils';
import { COMMAND_PRIORITY_EDITOR, createCommand, LexicalCommand } from 'lexical';

export interface SelectFontSizePayload {
  fontSize: string;
}

export const SELECT_FONT_SIZE: LexicalCommand<SelectFontSizePayload> = createCommand();

export function FontSizePlugin({ onChange }: { onChange: (fontSize: string) => void }) {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand<SelectFontSizePayload>(
        SELECT_FONT_SIZE,
        ({ fontSize }) => {
          onChange(fontSize);

          return true;
        },
        COMMAND_PRIORITY_EDITOR
      )
    );
  }, [editor, onChange]);

  return null;
}
